import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getAll } from 'apis/programs.api';

const useGetAllPrograms = (conds) => {
  const { data: programs, ...rest } = useQuery(['programs'], () => getAll(), {
    ...conds,
  });

  const data = useMemo(() => programs?.data ?? [], [programs]);
  return {
    data,
    rest,
  };
};

export default useGetAllPrograms;
